<template>
  <div class="d-flex justify-space-around">
    <v-btn
        class="ma-2"
        color="primary"
        icon
        text
        @click="$emit('google-click')">
      <v-icon large>mdi-google</v-icon>
    </v-btn>
  <!--   <v-btn
        class="ma-2"
        color="primary"
        @click="$emit('facebook-click')"
        icon
        text>
      <v-icon large>mdi-facebook</v-icon>
    </v-btn> -->
    <v-btn
        class="ma-2"
        color="primary"
        @click="$emit('apple-click')"
        icon
        text>
      <v-icon large>mdi-apple</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "SocialButtons"
}
</script>

<style scoped>

</style>